<ion-header mode="ios" [class.safearea]="!capacitor.map">
  <ion-toolbar>
    <ion-title>
      <div class="switcher {{ capacitor.scheme }}" (click)="openPopover($event)">{{ capacitor.translateString(type) }}</div>
    </ion-title>
    <ion-popover #switcher trigger-action="click" side="bottom" alignment="end">
      <ng-template>
        <ion-item button detail="false" lines="none" [class.active]="type == 'Goals'" (click)="switchContent('Goals')">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/target-04.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/target-04.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Goals') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
        </ion-item>
        <ion-item button detail="false" lines="none" detail="false" [class.active]="type == 'Places'" (click)="switchContent('Glaces')">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/globe-05.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/globe-05.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Places') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
        </ion-item>
        <ion-item button detail="false" lines="none" detail="false" [class.active]="type == 'Friends'" (click)="switchContent('Friends')">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/users-03.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/users-03.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Friends') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
        </ion-item>
        <ion-item button detail="false" lines="none" detail="false" [class.active]="type == 'Calendar'" (click)="switchContent('Calendar')">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/calendar-date.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/calendar-date.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Calendar') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
          <ion-label class="label new">NEW</ion-label>
        </ion-item>
        <ion-item button class="inactive" detail="false" lines="none" detail="false" [class.active]="type == 'Journal'">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/book-open-01.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/book-open-01.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Journal') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
          <ion-label class="label soon">SOON</ion-label>
        </ion-item>
        <ion-item button class="inactive" detail="false" lines="none" detail="false" [class.active]="type == 'Passport'">
          <ion-icon class="default" [src]="'/assets/icons/' + capacitor.scheme + '/passport-02.svg'"></ion-icon>
          <ion-icon class="selected" [src]="'/assets/icons/color/passport-02.svg'"></ion-icon>
          <ion-label>{{ capacitor.translateString('Passport') }}</ion-label>
          <ion-icon class="check" [src]="'/assets/icons/color/active.svg'" slot="end"></ion-icon>
          <ion-label class="label soon">SOON</ion-label>
        </ion-item>
      </ng-template>
    </ion-popover>
    <ion-buttons slot="end">
      <!-- FUTURE
      <ion-button (click)="openShare()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/share-01.svg'"></ion-icon>
      </ion-button>
      -->
      <ion-button aria-label="Account" class="avatar" [class.noimg]="avatar" [style.background-image]="avatar ? 'url('+ avatar +')' : ''" (click)="openAccount()">
        <div class="badge" *ngIf="data && data?.verified == false"></div>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content #content>
  <!-- Notifications -->

  <ion-grid class="message" *ngIf="data && data?.invites">
    <ion-list>
      <button ion-button class="cta big notifications" (click)="openNotifications()">
        <ion-icon src="/assets/icons/color/bell-01.svg"></ion-icon>
        <span>{{ capacitor.translateString('NotificationsNew') }}</span>
      </button>
    </ion-list>
  </ion-grid>

  <!-- Maximum -->

  <ion-grid class="message" *ngIf="data && !data?.premium && data?.maximum">
    <ion-list>
      <button ion-button class="cta big premium" (click)="openPremium()">
        <ion-icon src="/assets/icons/dark/check-verified-02.svg"></ion-icon>
        <span>{{ capacitor.translateString('PremiumGo') }}</span>
      </button>
    </ion-list>
  </ion-grid>

  <!-- Tabs -->

  <tab-goals *ngIf="type == 'Goals'"></tab-goals>
  <tab-places *ngIf="type == 'Places'"></tab-places>
  <tab-friends *ngIf="type == 'Friends'"></tab-friends>
  <tab-calendar *ngIf="type == 'Calendar'"></tab-calendar>
  <tab-journal *ngIf="type == 'Journal'"></tab-journal>
  <tab-passport *ngIf="type == 'Passport'"></tab-passport>
</ion-content>
